import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SettingsService } from '../services/settings/settings.service';

export const sessionSettingsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isSgiRequest(req.urlWithParams || req.url) || req.headers.has(SettingsService.sessionSettingsHeader)) {
    return next(req);
  }
  const headers = SettingsService.sessionSettingsHeaders();
  const value = headers.get(SettingsService.sessionSettingsHeader);
  return value
    ? next(req.clone({ setHeaders: { [SettingsService.sessionSettingsHeader]: value } }))
    : next(req);
};

function isSgiRequest(url: string): boolean {
  return url.startsWith(environment.SGI_API_URL);
}
